var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof mfe_shared_components !== "undefined") return resolve();
	__webpack_require__.l("https://static-qa.blinkng.eu/mf-shared-components/_next/static/chunks/remoteEntry.js", function(event) {
		if(typeof mfe_shared_components !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "mfe_shared_components");
}).then(function() { return mfe_shared_components; });